import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SubscriptionService } from '@app/+authenticated/+reports/shared/subscriptions/subscription.service';
import { SBHeaderAvatarComponent } from '@app/+authenticated/shared/sb-header/buttons/sb-header-avatar.component';
import { SBHeaderService } from '@app/+authenticated/shared/sb-header/sb-header.service';
import { SBProfileDropdownComponent } from '@app/+authenticated/shared/sb-header/sb-profile-dropdown/sb-profile-dropdown';
import { EmployeeModel } from '@app/reducers/orm/employee/employee.model';
import { getAuthenticatedUser } from '@app/reducers/orm/employee/employee.selectors';
import { doPermissionCheck } from '@app/reducers/orm/permission/permission.service';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { AppState } from '@reducers/interfaces';
import { ButtonComponent } from '@sb/ui/button';
import { IconComponent } from '@sb/ui/icon';
import { LaddaDirective } from '@sb/ui/ladda';
import { LogoComponent } from '@sb/ui/logo';
import { finalize, Observable, take } from 'rxjs';

@Component({
  selector: 'app-paused',
  imports: [
    AsyncPipe,
    TranslatePipe,
    IconComponent,
    ButtonComponent,
    LaddaDirective,
    SBHeaderAvatarComponent,
    SBProfileDropdownComponent,
    LogoComponent,
  ],
  templateUrl: './paused.component.html',
})
export class PausedComponent {
  private store = inject<Store<AppState>>(Store);
  private subscriptionService = inject(SubscriptionService);
  private router = inject(Router);
  private headerService = inject(SBHeaderService);

  canManageAccount: boolean;
  loading: boolean;
  authenticatedUser: EmployeeModel;
  profileDropdownOpen$: Observable<boolean>;

  constructor() {
    void this.store
      .select(getAuthenticatedUser)
      .pipe(take(1))
      .subscribe((user) => {
        this.authenticatedUser = user;
      });

    void this.store
      .select(
        doPermissionCheck({
          permissions: 'Manage account',
          userId: 'me',
          departments: 'any',
        }),
      )
      .pipe(take(1))
      .subscribe((canManageAccount) => {
        this.canManageAccount = canManageAccount;
      });

    this.profileDropdownOpen$ = this.headerService.profileDropdownOpen$;
  }

  resumeSubscription() {
    this.loading = true;
    void this.subscriptionService
      .resumeSubscription()
      .pipe(finalize(() => (this.loading = false)))
      .subscribe(() => {
        this.router.navigate(['/dashboard']);
      });
  }
}
